import React from 'react';
import AltLogo from '../../images/mcmasterLogoWhiteMar.png';
import './footer.css';
import {Link} from 'react-router-dom';

const Footer = () => {
    return (
        <div className='page-footer'>
            <img src={AltLogo} alt="Logo" class = "footer-logo" />
            <div class = "footer-text">
            <p> Contact </p>
            <p> Privacy Policy </p>
            <p> Terms of Use </p>
            <Link to = "/admin" class = "astext">
                <p> Admin </p>
            </Link>
            </div>
        </div>
    )
};

export default Footer;